// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30M_i","largestCol":"styles_largestCol__3cRP1","smallestCol":"styles_smallestCol__2TxA2"};